<template>
    <div class="row" v-if="this.sugggestdata.uri">

          <div class="col-md-12 ">
            <h3 class="range-buttons">{{__('messages.destination_title')}}</h3>
          </div>

        <div class="col-md-4 mb-2">
            <div class="range-btn">
                <a :href="`${siteConfig.siteUrl}${reservationLinks[0]}`">
                    <span class="content-range-btn">
                        <span class="title-range">
                            {{__('messages.break_weekend')}}
                        </span>
                        <span class="date-range">
                            ({{ this.startDates.ThisWeekend.format('D [al] ') + this.startDates.ThisWeekendFinal.format('D [de] MMMM')  }})
                        </span>
                    </span>
                    <span class="action-range-btn">
                        <span class="arrow-right"></span>
                    </span>
                </a>
            </div>
        </div>
        <div class="col-md-4 mb-2">
            <div class="range-btn">
                <a :href="`${siteConfig.siteUrl}${reservationLinks[1]}`">
                    <span class="content-range-btn">
                        <span class="title-range">{{__('messages.escape_two_weeks')}} </span>
                        <span class="date-range">
                            ({{this.startDates.TwoWeeks.format('D [al] ') + this.startDates.TwoWeeksFinal.format('D [de] MMMM') }})
                        </span>
                    </span>
                    <span class="action-range-btn">
                        <span class="arrow-right"></span>
                    </span>
                </a>
            </div>
        </div>
        <div class="col-md-4 mb-2">
            <div class="range-btn">
                <a :href="`${siteConfig.siteUrl}${reservationLinks[2]}`">
                    <span class="content-range-btn">
                        <span class="title-range">{{__('messages.plan_vacation')}}</span>
                        <span class="date-range">
                            ({{ this.startDates.TwoMonths.format('D [al] ') + this.startDates.TwoMonthsFinal.format('D [de] MMMM')}})
                        </span>
                    </span>
                    <span class="action-range-btn">
                        <span class="arrow-right"></span>
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
    const site = window.__pt.settings.site;


    export default {
        props: {
            sugggestdata: Object,
            destinationUri: String
        },
        data() {
            return {
                reservationLinks: [],
                startDates: {
                    ThisWeekend: window.moment().day(5),
                    ThisWeekendFinal: window.moment().locale(site.culture).day(5).add(2, 'days'),
                    TwoWeeks: window.moment().add(1, "weeks").day(5),
                    TwoWeeksFinal: window.moment().locale(site.culture).add(1, "weeks").day(5).add(2, 'days'),
                    TwoMonths: window.moment().add(50, "days").day(5),
                    TwoMonthsFinal: window.moment().locale(site.culture).add(50, "days").day(5).add(2, 'days'),
                },
                nights: 2,
                siteConfig: site,
            };
        },
        mounted() {
           
            
            let path_hotel = this.siteConfig.pathHoteles;
            let queryString = `${path_hotel}${this.sugggestdata.uri}_d${this.sugggestdata.id}?placeId=${this.sugggestdata.id}&placeType=${this.sugggestdata.type}&Room1.Adults=2&Room1.Kids=0&Room1.AgeKids=&CheckIn=${moment(this.startDates.ThisWeekend).format('YYYY-MM-DD')}&CheckOut=${moment(this.startDates.ThisWeekend).add(this.nights, 'days').format('YYYY-MM-DD')}`;
            this.reservationLinks.push(queryString);
            queryString = `${path_hotel}${this.sugggestdata.uri}_d${this.sugggestdata.id}?placeId=${this.sugggestdata.id}&placeType=${this.sugggestdata.type}&Room1.Adults=2&Room1.Kids=0&Room1.AgeKids=&CheckIn=${moment(this.startDates.TwoWeeks).format('YYYY-MM-DD')}&CheckOut=${moment(this.startDates.TwoWeeks).add(this.nights, 'days').format('YYYY-MM-DD')}`;
            this.reservationLinks.push(queryString);
            queryString = `${path_hotel}${this.sugggestdata.uri}_d${this.sugggestdata.id}?placeId=${this.sugggestdata.id}&placeType=${this.sugggestdata.type}&Room1.Adults=2&Room1.Kids=0&Room1.AgeKids=&CheckIn=${moment(this.startDates.TwoMonths).format('YYYY-MM-DD')}&CheckOut=${moment(this.startDates.TwoMonths).add(this.nights, 'days').format('YYYY-MM-DD')}`;
            this.reservationLinks.push(queryString);
        }
    };
</script>
